module.exports = __webpack_public_path__ + "static/media/ocean_bubbles.69c322ce.mp3";